// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__1181H","dragIcon":"SortableItem_dragIcon__2pAfg","disabled":"SortableItem_disabled__TdpPF"};